import { dashboardConstants } from "../constants/dashboard.constants";
import {dashboardService} from "../services/dashboard.service";

function getDashboard() {
    return dispatch => {
        dispatch(request());
        dashboardService.getDashboard()
            .then(
                dashboardModel => {
                    dispatch(success(dashboardModel));
                },
                error => {
                    dispatch(failure(error));
                }
            );
        dashboardService.readExhibitionState()
            .then(
                exhibitionState => {
                    dispatch(successExhibitionState(exhibitionState))
                },
                error => {
                    dispatch(failureExhibitionState(error))
                }
            )
    };

    function request() { return { type: dashboardConstants.DASHBOARD_STORE_REQUEST } }
    function success(dashboardModel) { return { type: dashboardConstants.DASHBOARD_STORE_SUCCESS, dashboardModel} }
    function failure(error) { return {type: dashboardConstants.DASHBOARD_STORE_FAILURE, error} }

    function successExhibitionState(exhibitionState) { return { type: dashboardConstants.EXHIBITION_STATE_SUCCESS, exhibitionState } }
    function failureExhibitionState(error) { return {type: dashboardConstants.EXHIBITION_STATE_FAILURE, error } }
}

function clearDashboard() {

    return dispatch => {
        dispatch(clear())
    };

    function clear() { return {type: dashboardConstants.DASHBOARD_STORE_CLEAR } }
}

export const dashboardActions = {
    getDashboard,
    clearDashboard
};
